module.exports = __webpack_public_path__ + "img/rhapsody-in-blue.0d4a5f5e.png";